export const ACTIVATE_AUTH_LAYOUT = "auth_layout";
export const ACTIVATE_NON_AUTH_LAYOUT = "non_auth_layout";
export const TOGGLE = "toggle";
